/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { Component } from "react";
import { getMessage } from "utils/TranslationUtil";
import ReadAloudIcon from "dc-icons/viewer2021/Web_Mobile/SDC_TileReadAloud_64.svg";
import { VERB_READ_ALOUD, supportedFileExtensions } from "constants/enums";
import { isIOS, isMac, isTouchDevice } from "dc-preview-utils/src/Utils/DeviceUtils";
import readAloudNavbarIcon from "dc-icons/viewer2021/SDC_ReadAloudListen_18_N.svg";

class ReadAloudBootstrap extends Component {
  getLabel = () => getMessage("verb.readaloud.label");

  getIcon = ({ context }) => {
    if (context === "MobileMvContextMenu") {
      return readAloudNavbarIcon;
    }
    return ReadAloudIcon;
  };

  initializeAction = (opts = {}) => {
    const isIOSDevice = isIOS() || (isMac() && isTouchDevice());
    if (opts.context === "ModernViewerMoreTools" && opts.showCallback && isIOSDevice) {
      opts.showCallback(false);
    }
  };

  getFileSelectionParams = () => ({
    acceptExtensions: Object.values(supportedFileExtensions),
    acceptConnectors: "all"
  });

  id = VERB_READ_ALOUD;

  render() {
    return null;
  }
}

export default ReadAloudBootstrap;
